import BaseModule from '$js/base/BaseModule';

export class ContentDateOfBirth {
  constructor() {
    const elements: NodeListOf<Element> = document.querySelectorAll('[data-dob]');

    if (!elements.length) {
      return;
    }

    elements.forEach((element: Element): void => {
      const dobString: string | null = element.getAttribute('data-dob');
      if (dobString) {
        const age: number = this.calculateAge(dobString);
        const currentText: string = element.textContent || '';
        element.textContent = `${currentText} (${BaseModule.getInstance().i18n.translate('age')} ${age.toString()})`;
      }
    });
  }

  private calculateAge(dateString: string): number {
    const dob = new Date(dateString);
    const today = new Date();

    let age: number = today.getFullYear() - dob.getFullYear();
    const monthDiff: number = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return age;
  }
}
